import { createSelector } from 'reselect';
import { DEFAULT_LOCALE } from 'containers/LanguageProvider/constants';

export const selectIntl = (state: any) => state.get('intl');

export const makeSelectLocale = () =>
  createSelector(selectIntl, (intl: any) => {
    if (intl && intl.get('locale')) {
      return intl.get('locale');
    }
    return DEFAULT_LOCALE;
  });
